const getAnalyticsEventBus = require('../common/getAnalyticsEventBus');

const analyticsEventBus = getAnalyticsEventBus();

/**
 * If the user is not logged in and the cart is empty, then show the modal
 * @returns {boolean} A boolean value.
 */
function shouldShowModal() {
  const urlParams = new URLSearchParams(window.location.search);
  const utmCampaignParam = urlParams.get('utm_campaign');
  const isCampaign =
    utmCampaignParam && utmCampaignParam.includes('RECUPERACION_CARRITOS');
  const userLoggedIn = gaInfo.login === 'logged';
  const cartEmpty = gaInfo.cart_total_items === '0';
  return isCampaign && !userLoggedIn && cartEmpty;
}

/**
 * It creates a bootstrap modal and shows it if user is not logged and cart is empty
 */
function init() {
  const modals = require('./modals');

  const $cartRecoveryModal = $('#cartRecoveryModal');

  if (shouldShowModal()) {
    $cartRecoveryModal.modal();
    // Send info for analytics
    analyticsEventBus.publish(analyticsEventBus.EVENTS.modalCartRecoveryOpened);
  }

  $cartRecoveryModal.on('hide.bs.modal', () => {
    // Send info for analytics
    analyticsEventBus.publish(analyticsEventBus.EVENTS.modalCartRecoveryClosed);
    $cartRecoveryModal.modal();
  });

  $cartRecoveryModal.on('shown.bs.modal', () => {
    const { lock, clearBodyLocks } = require('tua-body-scroll-lock');
    const { isIOSUserAgent } = require('../common/utils/device');

    const modalBackdrop = document.querySelector('.modal-backdrop');
    // Scroll IOS fix
    if (isIOSUserAgent() && modalBackdrop) {
      lock();
      $cartRecoveryModal.on('hide.bs.modal', clearBodyLocks);
    }
    // Fix for fade modals -> Two backdrops were created due to jQuery + Bootrap version problems
    if ($cartRecoveryModal.hasClass('fade')) {
      modals.fixFadeBackdrop();
    }
  });
}

module.exports = {
  init,
};
